import { Button, Typography } from '@breetometer/components';
import { BreadcrumbAngleIcon } from 'BreetAssets';
import { handleApiError, showToast } from 'BreetHelpers';
import { useSellCompleteWithFeesMutation } from 'BreetRedux';
import { useCallback } from 'react';

import type { IResolveTradeResolutionFees } from '../DialogResolveTrade.helpers';

const PayResolutionFee = ({ onBackLink, resolutionFee, transactionId, exitModals }: IResolveTradeResolutionFees) => {
	const [sellCompleteWithFees, { isLoading }] = useSellCompleteWithFeesMutation();

	const payandCompleteTransaction = useCallback(() => {
		sellCompleteWithFees(transactionId)
			.unwrap()
			.then(() => {
				showToast('success', 'Resolution fee paid successfully. Please check your transaction history');
				exitModals();
			})
			.catch(handleApiError);
	}, [exitModals, sellCompleteWithFees, transactionId]);

	return (
		<div className='resolvetrade_resolutionfees'>
			<div className='resolvetrade_header'>
				<BreadcrumbAngleIcon
					focusable
					className='resolvetrade_header_backlink cursor_pointer svg-dark'
					aria-label='Go back'
					role='button'
					tabIndex={0}
					onClick={onBackLink}
				/>
				<Typography
					as='h1'
					className='color-neutral-50'
				>
					Pay Resolution Fee
				</Typography>
			</div>

			<div className='resolvetrade_resolutionfees_body'>
				<Typography className='color-primary-50'>
					A <span className='color-tertiary-400'>${resolutionFee}</span> resolution fee will be deducted from the USD value of the
					received crypto and this transaction will be immediately completed.
				</Typography>
			</div>

			<div className='resolvetrade_resolutionfees_cta'>
				<Button
					label='Yes, Pay and Complete'
					type='button'
					isLoading={isLoading}
					onClick={payandCompleteTransaction}
					className='primary-hover'
				/>
				<Button
					label='No, Go Back'
					variant='outline'
					onClick={onBackLink}
					className='bg-primary-600 color-primary-100'
				/>
			</div>
		</div>
	);
};

export default PayResolutionFee;
